import { defineComponent as _defineComponent } from 'vue'
import { onBeforeMount, ref } from 'vue';

import {
  BaseText,
  HeadingDisplay,
  Heading,
  ButtonIconContextual
} from '@warrenbrasil/nebraska-web';
import { BalancesLoader } from './components/BalancesLoader';
import { BalancesError } from './components/BalancesError';
import { Money } from '@/modules/common/components/Money';
import { BalanceDetailsModal } from './components/BalanceDetailsModal';

import {
  getBalances,
  IBalancesResponse,
  IDetails
} from '@/modules/transaction/services/unified-account';


export default /*#__PURE__*/_defineComponent({
  __name: 'Balances',
  setup(__props) {

const isLoading = ref(true);
const hasError = ref(false);
const balances = ref<IBalancesResponse | null>(null);

const isDetailsModalOpen = ref(false);
const detailsModal = ref({});

function openDetailsModal(details: IDetails) {
  detailsModal.value = details;
  isDetailsModalOpen.value = true;
}

async function fetchBalances() {
  hasError.value = false;
  isLoading.value = true;

  try {
    balances.value = await getBalances();
  } catch {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

onBeforeMount(async () => {
  await fetchBalances();
});

return { __sfc: true,isLoading, hasError, balances, isDetailsModalOpen, detailsModal, openDetailsModal, fetchBalances, BaseText, HeadingDisplay, Heading, ButtonIconContextual, BalancesLoader, BalancesError, Money, BalanceDetailsModal }
}

})